type EntityOption = {
	label: string;
	id: string;
};

export type BulkReplyFilters = {
	from: number;
	to: number;
};

export const TICKET_OPTIONS: EntityOption[] = [
	{
		label: 'Resolved',
		id: 'Resolved'
	},
	{
		label: 'Open',
		id: 'Open'
	},
	{
		label: 'Closed',
		id: 'Closed'
	},
	{
		label: 'Pending',
		id: 'Pending'
	}
];
